import React from 'react';
import { ButtonV2 } from '@withjoy/joykit';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { pxToRem } from '@withjoy/joykit/theme';

interface MediaComponentsAccordionItemProps
  extends Readonly<{
    onClick: () => void;
    icon: React.ReactNode;
    title: string;
  }> {}

/**
 * Accordion item without border - used inside MediaComponentsAccordion
 * Maintains same styling as LayoutAddComponentListItem but without border
 */
export const MediaComponentsAccordionItem: React.FC<MediaComponentsAccordionItemProps> = ({ onClick, icon, title }) => {
  const handleClick = useEventCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    onClick();
  });

  return (
    <ButtonV2
      _hover={{ backgroundColor: 'mono2', color: 'linkHover' }}
      _active={{ backgroundColor: 'mono2', color: 'linkHover' }}
      intent="neutral"
      color="mono14"
      columnGap={5}
      paddingX={6}
      minHeight={pxToRem(82)}
      startIcon={icon}
      alignItems="center"
      onClick={handleClick}
      typographyVariant="hed2"
      width="100%"
      justifyContent="flex-start"
      backgroundColor="transparent"
    >
      {title}
    </ButtonV2>
  );
};
